export default "__VITE_ASSET__CrrVxL9u__"